import React from 'react';
import classes from './index.module.scss';
import { ReactComponent as DeleteIcon } from '../../assets/icons/not-check.svg';
import LinesEllipsis from 'react-lines-ellipsis'
import { Link } from 'react-router-dom';
import moment from 'moment';

const InboxTableBody = ({ list, deleteMessage }) => {
  return (
    <>
      {
        list.map(item => {
          const { created, body, author, id, is_read } = item;
          return (
            <tr 
              key={id}
            >
              <td>
                <Link
                  to={`/message?id=${id}&type=message`}
                >
                  <div className={`${is_read ? classes.Title_Normal : classes.Title_Bold} ${classes.Vertical_Middle}`}>{moment(created).format('YYYY-MM-DD')}</div>
                </Link>
              </td>
              <td>
                <Link
                  to={`/message?id=${id}&type=message`}
                >
                  <LinesEllipsis
                    className={`${is_read ? classes.Title_Normal : classes.Title_Bold} ${classes.Vertical_Middle}`}
                    text={body}
                    maxLine='1'
                    ellipsis='...'
                    trimRight
                    basedOn='letters'
                  />
                </Link>
              </td>
              <td>
                <Link
                  to={`/message?id=${id}&type=message`}
                >
                  <div className={`${is_read ? classes.Title_Normal : classes.Title_Bold} ${classes.Vertical_Middle} text-right`}>{author.email}</div>
                </Link>
              </td>
              <td className={`${classes.Vertical_Middle} text-right`}>
                <DeleteIcon 
                  className={classes.Delete_Icon}
                  onClick={() => deleteMessage(id)}
                />
              </td>
            </tr>
          )
        })
      }
    </>
  )
}

export default InboxTableBody;